import React, { useRef } from 'react'
import { Button, Modal, Typography } from 'antd'
import { useDrag, useDrop } from 'react-dnd'
import PrivateImage from 'src/components/PrivateImage'
import { DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import s from './index.module.scss'

const { Text } = Typography

interface CarouselItemProps {
  metaverse: MainDiscovery
  categoryId: string
  
  onRemove: (main: MainDiscovery) => void
}

const CarouselItem: React.FC<CarouselItemProps> = ({
  metaverse,
  categoryId,

  onRemove = () => null,
}) => {
  const ref = useRef(null)
  const dndType = `card_${categoryId}`
  const [, drag] = useDrag(() => ({
    type: dndType,
    item: {
      id: metaverse.id,
    },
  }))
 

   const onRemoveClick = React.useCallback(() => {
      Modal.confirm({
        title: (
          <p>
            You&apos;re deleting <strong>{metaverse?.type ==='METAVERSE' || metaverse?.type === 'EVENT'? metaverse.name:metaverse.title}</strong>
          </p>
        ),
        icon: <ExclamationCircleOutlined />,
        onOk: () => onRemove && onRemove(metaverse),
      })
    }, [metaverse])

  
  return (
    <div
      
      className={s.carouselItem}
    >
      <div ref={ref} className={s.carouselItemCard}>
        <PrivateImage
          src={metaverse.imageS3Path}
          width={'100%'}
          height={140}
          preview={false}
        />
        <div className={s.carouselItemMeta}>
<Text strong>
  {metaverse?.type === 'METAVERSE' || metaverse?.type === 'EVENT' 
    ? metaverse.name 
    : metaverse.title}
</Text>          <Text italic type="secondary">
            Type: {metaverse.type}
          </Text>
        </div>
        {metaverse?.type !== 'REFERRAL' && (
          <Button
            type="primary"
            danger
            shape="circle"
            icon={<DeleteOutlined />}
            size="small"
            className={s.carouselItemDelBtn}
            onClick={onRemoveClick}
          />
        )}
      </div>
    </div>
  )
}
export default CarouselItem
